module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('router-link', {
    staticClass: "fixedTop",
    attrs: {
      "to": {
        name: 'search'
      }
    }
  }, [_c('div', [_c('i', {
    staticClass: "icon icon-search"
  }), _vm._v(" 请输入关键字")])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_vm._l((_vm.roots), function(item, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": {
          name: 'bookshelf',
          params: {
            catid: item.id
          },
          query: {
            name: item.category
          }
        }
      }
    }, [_c('i', {
      staticClass: "icon",
      class: _vm._f("icon")(item.category)
    }), _vm._v("\n      " + _vm._s(item.category) + "\n    ")])
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'category-all'
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-more"
  }), _vm._v("\n      全部\n    ")])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e5b6e74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/category/index.vue
// module id = 322
// module chunks = 0